<template>
  <div class="jdjr-official-website-body">
    <Topchild />
    <div class="jdjr-official-website-modular" :id="1">
      <div v-for="(obj, index) in modularData" :key="index" :style="{ backgroundImage: 'url(' + obj.moduleBackground + ')' }" class="jdjr-official-website-modular-children">
        <img :src="obj.nameImg" class="jdjr-official-website-text-img" />
        <div v-html="obj.text" class="jdjr-official-website-text-title"></div>
      </div>
    </div>
    <div class="jdjr-official-website-responsibility" :id="2">
      <img src="@/assets/img/responsibility-text.png" class="responsibility-text" />
      <div class="responsibility-content">{{ responsibilityContent }}</div>
      <div class="responsibility-footer">
        <div class="responsibility-footer-left">
          <div class="responsibility-footer-left-title">截至目前</div>
          <div class="responsibility-footer-left-number">1930<span>万</span></div>
          <div class="responsibility-footer-left-text people-all-number">累计参与人数</div>
          <div class="responsibility-footer-left-number">4159<span>万</span></div>
          <div class="responsibility-footer-left-text">累计捐出订单笔数</div>
        </div>
        <div class="responsibility-footer-right">
          <responsibility-swiper />
        </div>
      </div>
      <div class="jdjr-official-website-responsibility-position-img"></div>
    </div>
    <div class="jdjr-official-website-partner" :id="3">
      <img src="@/assets/img/cooperative-partner.png" class="jdjr-official-website-partner-img" alt />
      <div class="jdjr-official-website-partner-content">
        <!-- <img v-for="(obj,index) in partnerList" :key="index" :src="obj.url" :class="{firstClass:index === 0}" />-->
        <panter-swiper />
      </div>
    </div>
    <div class="jdjr-official-website-footer">
      <div class="footer-children">
        <div class="footer-children-top">
          <img src="@/assets/img/contact.png" alt />
          <img src="@/assets/img/logo-white.png" alt />
        </div>
        <div class="footer-children-bottom">
          <div class="footer-children-bottom-left">
            <div>京东金融总部 北京市亦庄经济开发区京东大厦A座</div>
            <div class="bottom-left-center">邮编 100110</div>
            <div>客户服务咨询投诉热线</div>
            <div class="footer-children-bottom-left-phone">95118</div>
            <div>Copyright © {{ curYear }} 京东科技版权所有</div>
          </div>
          <div class="footer-children-bottom-right">
            <div class="footer-children-bottom-right-qrcode">
              <div v-for="(obj, index) in qrCodeList" :key="index" class="qrcode-div">
                <div>{{ obj.title }}</div>
                <img :src="obj.url" alt />
              </div>
            </div>
            <div class="footer-children-bottom-right-content">
              <span v-for="(item, index) in footerList" :key="index">
                <a :href="item.url" :clstag="item.clstag" target="_blank" rel="noopener noreferrer">{{ item.title }}</a>
                |
              </span>

              <!-- <router-link
                :to="{path:'/privacy-protocol/'}"
                clstag="DSGJ|85742"
                >隐私政策</router-link
              >丨 -->
              <!-- <a href="https://img12.360buyimg.com/imagetools/jfs/t1/156031/17/31968/1869415/6361e36cEf17d1faf/b35e83f766b31a69.png" target="_blank" clstag="DSGJ|85743">营业执照</a> | -->
              <!-- <a
                href="https://jrhelp.jd.com"
                target="_blank"
                clstag="DSGJ|85744"
                >常见问题</a
              >丨 -->
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">苏ICP备19060636号-1</a>
              <!-- 丨 <img src="@/assets/img/plice.png" /><a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11030102010689"
                target="_blank"
                >京公网安备 11030102010689号</a
              > -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Topchild from './component/topchild.vue';
import ResponsibilitySwiper from './component/responsibilitySwiper.vue';
import PanterSwiper from './component/panterSwiper.vue';
import { getDataSourceStatic } from './../../utils/index';

export default {
  name: 'JrFeIndex',

  components: {
    Topchild,
    ResponsibilitySwiper,
    PanterSwiper
  },

  data() {
    return {
      modularData: [
        {
          moduleBackground: require('@/assets/img/modular-img-one.png'),
          nameImg: require('@/assets/img/modular-one.png'),
          text: '<div>快速放款</div><div>随借随还</div><div>安全合规</div>'
        },
        {
          moduleBackground: require('@/assets/img/modular-img-two.png'),
          nameImg: require('@/assets/img/modular-two.png'),
          text: '<div>先消费、后付款</div><div>实时审批</div><div>随心分期</div>'
        },
        {
          moduleBackground: require('@/assets/img/modular-img-three.png'),
          nameImg: require('@/assets/img/modular-three.png'),
          text: '<div>灵活存取、乐享收益</div><div>支持理财产品购买</div><div>商城消费购物</div><div>金条、白条还款等场景</div>'
        },
        {
          moduleBackground: require('@/assets/img/modular-img-four.png'),
          nameImg: require('@/assets/img/modular-four.png'),
          text: '<div>合规持牌基金代销平台</div><div>基金销售种类丰富</div><div>满足各类人群理财需求</div>'
        },
        {
          moduleBackground: require('@/assets/img/modular-img-five.png'),
          nameImg: require('@/assets/img/modular-five.png'),
          text: '<div>稳健的保险合作渠道，满足多元化保险需求，</div><div>包含健康险、意外险、人寿险、重疾险、</div>财产险，车险等保险产品'
        },
        {
          moduleBackground: require('@/assets/img/modular-img-six.png'),
          nameImg: require('@/assets/img/modular-six.png'),
          text: '<div>下载京东金融APP体验</div>'
        }
      ],
      responsibilityContent:
        '“京东金融-订单公益”是京东践行企业CSR，发起全民公益新风尚的核心项目，倡导京东集团“有责任的消费”主旨 。在京东APP消费使用京东支付或白条交易完成的订单，均可选择将订单数兑换为公益物资，并由京东为您配捐到指定公益项目中。迄今为止，项目通过618、双11以及3.8三期传播，累计有效传播量超过3亿人次，公益涉及包括流浪动物救助、女性公益、乡村振兴、儿童教育等多个领域。',

      qrCodeList: [
        {
          url: require('@/assets/img/network-voice-service.png'),
          title: '网络语音服务(免话费)'
        },
        {
          url: require('@/assets/img/code-one.png'),
          title: '京东金融公众号'
        },
        {
          url: require('@/assets/img/code-three.png'),
          title: '白条公众号'
        },
        {
          url: require('@/assets/img/code-two.png'),
          title: '金条公众号'
        }
      ],
      marginLeft: 0,
      footerList: [],
      curYear: ''
    };
  },
  mounted() {
    if (window.__qd__) {
      window.__qd__.imp({ cls: 'DSGJ|85201' });
    }

    this.curYear = new Date().getFullYear()
    this.footerList = getDataSourceStatic('footerList') || [];
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
.jdjr-official-website-body {
  background: rgba(244, 245, 247, 1);
  .jdjr-official-website-modular {
    width: 1440px;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 80px;
    .jdjr-official-website-modular-children {
      width: 470px;
      height: 300px;
      background-size: 100%;
      margin-bottom: 15px;
      .jdjr-official-website-text-img {
        // width: toRem(124);
        height: 43px;
        margin: 36px 0 0 40px;
      }
      .jdjr-official-website-text-title {
        // width: toRem(80);
        margin-top: 20px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
        line-height: 32px;
        margin-left: 40px;
      }
    }
  }
  .jdjr-official-website-responsibility {
    width: 1440px;
    height: 579px;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    margin: auto;
    margin-top: 65px;
    position: relative;
    .jdjr-official-website-responsibility-position-img {
      position: absolute;
      right: 0;
      top: 0;
      width: 414px;
      height: 389px;
      background: url('@/assets/img/responsibility-img.png') no-repeat;
      background-size: 100%;
    }
    .responsibility-text {
      // width: toRem(240);
      height: 32px;
      margin: 40px 0 12px 40px;
      z-index: 10;
    }
    .responsibility-content {
      width: 1360px;
      height: 96px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 300;
      line-height: 32px;
      color: rgba(153, 153, 153, 1);
      position: relative;
      z-index: 10;
      margin: auto;
    }
    .responsibility-footer {
      position: relative;
      z-index: 10;
      display: flex;
      .responsibility-footer-left {
        box-sizing: border-box;
        width: 315px;
        padding-left: 40px;
        .responsibility-footer-left-title {
          line-height: 32px;
          font-size: 20px;
          font-family: FZLTXIHJW;
          font-weight: normal;
          color: rgba(0, 0, 0, 1);
          margin-top: 32px;
        }
        .responsibility-footer-left-number {
          // line-height: 62px;
          font-size: 52px;
          font-family: 'UDC 1.04-Bold';
          font-weight: bold;
          color: rgba(239, 64, 52, 1);
          margin-top: 37px;
          display: flex;
          align-items: center;
          span {
            display: flex;
            align-items: center;
            line-height: 62px;
            font-size: 44px;
            font-family: PingFang SC;
            font-weight: 600;
            color: rgba(239, 64, 52, 1);
            padding-top: 4px;
          }
        }
        .responsibility-footer-left-text {
          line-height: 32px;
          font-size: 20px;
          font-family: FZLTXIHJW;
          font-weight: normal;
          color: rgba(153, 153, 153, 1);
        }
      }
      .responsibility-footer-right {
        height: 299px;
        margin-top: 49px;
        .responsibility-footer-right-img {
          width: 169px;
          height: 299px;
          margin-right: 14px;
        }
      }
    }
  }
  .jdjr-official-website-partner {
    width: 1440px;
    height: 281px;
    margin: auto;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    margin-top: 80px;
    .jdjr-official-website-partner-img {
      // width: toRem(156);
      height: 32px;
      margin: 46px 0 32px 42px;
    }
    .jdjr-official-website-partner-content {
      display: flex;
      box-sizing: border-box;
      // padding-left: toRem(40);
      width: 100%;
      overflow: hidden;
      img {
        // width: toRem(280);
        height: 80px;
        margin-right: 24px;
      }
    }
  }
  .jdjr-official-website-footer {
    width: 100%;
    height: 461px;
    background: rgba(17, 17, 17, 1);
    margin-top: 80px;
    .footer-children {
      box-sizing: border-box;
      width: 1440px;
      height: 100%;
      margin: auto;
      padding-top: 81px;
      padding-left: 42px;
      padding-right: 40px;
      .footer-children-top {
        height: 41px;
        img {
          &:nth-child(1) {
            // width: toRem(156);
            float: left;
            height: 32px;
            margin-top: 5px;
          }
          &:nth-child(2) {
            // width: toRem(180);
            height: 41px;
            float: right;
          }
        }
      }
      .footer-children-bottom {
        display: flex;
        .footer-children-bottom-left {
          // width: 500px;
          line-height: 28px;
          height: 28px;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 300;
          color: rgba(153, 153, 153, 1);
          margin-top: 36px;
          .bottom-left-center {
            margin: 12px 0;
          }

          .footer-children-bottom-left-phone {
            font-size: 52px;
            font-family: 'UDC 1.04-Bold';
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
            line-height: 62px;
            margin-bottom: 46px;
            margin-top: 5px;
          }
        }
        .footer-children-bottom-right {
          flex: 1;
          margin-top: 39px;
          .footer-children-bottom-right-qrcode {
            float: right;
            display: flex;
            .qrcode-div {
              width: 140px;
              text-align: center;
              margin-left: 40px;
              div {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: 300;
                color: rgba(153, 153, 153, 1);
                line-height: 28px;
                margin-bottom: 10px;
              }
              img {
                width: 140px;
                height: 140px;
              }
              &:first-child {
                position: relative;
                width: 260px;
                margin-right: 20px;
                margin-left: 0;
                &::after {
                  content: '';
                  display: block;
                  position: absolute;
                  bottom: 0;
                  right: 0;
                  height: 140px;
                  width: 1px;
                  background-color: #666666;
                }
              }
            }
          }
          .footer-children-bottom-right-content {
            width: 100%;
            text-align: right;
            // overflow:hidden;
            // white-space: nowrap;
            // text-overflow: ellipsis;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 300;
            color: rgba(153, 153, 153, 1);
            height: 28px;
            float: right;
            margin-top: 37px;
            // display: flex;
            // align-items: center;
            a {
              text-decoration: none;
              color: rgba(153, 153, 153, 1);
            }
          }
        }
      }
    }
  }
}
</style>
